import { fetcher } from '@commenda/utils';

interface UnarchiveComplianceItemResponse {
  success: boolean;
}

export async function unarchiveComplianceItem(
  complianceItemId: string
): Promise<UnarchiveComplianceItemResponse> {
  const res = await fetcher(`compliance/${complianceItemId}/unarchive`, {
    method: 'POST',
  });

  if (!res.ok) {
    return { success: false };
  }
  return { success: true };
}
